import type { IntegrationJob } from "../../shared/types";

export const mockJobs: IntegrationJob[] = [
  {
    id: "job-synapse-customer-daily",
    name: "Customer 360 Daily Load",
    description: "Daily Synapse pipeline that hydrates the customer mart.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-dataops",
    workspaceName: "synw-prod-dataops",
    pipelineName: "Customer360DailyLoad",
    triggerName: "daily-0500",
    expectedStartTime: "2026-06-02T05:00:00Z",
    cronExpression: "0 5 * * *",
    graceMinutes: 15,
    expectedDurationMinutes: 45,
    status: "SUCCEEDED",
    severity: "HIGH",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-customer-001.json",
    createdAt: "2026-04-21T14:00:00Z",
    updatedAt: "2026-06-02T05:43:00Z"
  },
  {
    id: "job-synapse-finance-close",
    name: "Finance Close Pipeline",
    description: "Critical month-end finance integration pipeline.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-finance",
    workspaceName: "synw-prod-finance",
    pipelineName: "FinanceClosePipeline",
    triggerName: "weekday-0630",
    expectedStartTime: "2026-06-02T06:30:00Z",
    cronExpression: "30 6 * * 1-5",
    graceMinutes: 10,
    expectedDurationMinutes: 60,
    status: "FAILED",
    severity: "CRITICAL",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/errors/source=synapse/year=2026/month=06/day=02/run-finance-019.json",
    createdAt: "2026-04-21T14:05:00Z",
    updatedAt: "2026-06-02T07:18:00Z"
  },
  {
    id: "job-synapse-inventory-hourly",
    name: "Inventory Availability Sync",
    description: "Hourly warehouse availability pipeline.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-supply",
    workspaceName: "synw-prod-supply",
    pipelineName: "InventoryAvailabilitySync",
    triggerName: "hourly",
    expectedStartTime: "2026-06-02T13:00:00Z",
    cronExpression: "0 * * * *",
    graceMinutes: 8,
    expectedDurationMinutes: 20,
    status: "RUNNING",
    severity: "MEDIUM",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-inventory-044.json",
    createdAt: "2026-04-24T12:30:00Z",
    updatedAt: "2026-06-02T13:09:00Z"
  },
  {
    id: "job-synapse-vendor-nightly",
    name: "Vendor Compliance Extract",
    description: "Nightly partner compliance extract expected before business open.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-partner",
    workspaceName: "synw-prod-partner",
    pipelineName: "VendorComplianceExtract",
    triggerName: "nightly-0330",
    expectedStartTime: "2026-06-02T03:30:00Z",
    cronExpression: "30 3 * * *",
    graceMinutes: 20,
    expectedDurationMinutes: 35,
    status: "MISSING",
    severity: "HIGH",
    owner: "Samuel Kim",
    isActive: true,
    createdAt: "2026-05-01T17:00:00Z",
    updatedAt: "2026-06-02T04:02:00Z"
  },
  {
    id: "job-synapse-orders-late",
    name: "Orders Operational Feed",
    description: "Order event pipeline started after the configured grace period.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-commerce",
    workspaceName: "synw-prod-commerce",
    pipelineName: "OrdersOperationalFeed",
    triggerName: "daily-1000",
    expectedStartTime: "2026-06-02T10:00:00Z",
    cronExpression: "0 10 * * *",
    graceMinutes: 10,
    expectedDurationMinutes: 25,
    status: "LATE",
    severity: "MEDIUM",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-orders-208.json",
    createdAt: "2026-04-30T15:00:00Z",
    updatedAt: "2026-06-02T10:47:00Z"
  },
  {
    id: "job-synapse-risk-long-running",
    name: "Risk Scoring Batch",
    description: "Scoring pipeline has exceeded the expected duration threshold.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-risk",
    workspaceName: "synw-prod-risk",
    pipelineName: "RiskScoringBatch",
    triggerName: "weekday-1100",
    expectedStartTime: "2026-06-02T11:00:00Z",
    cronExpression: "0 11 * * 1-5",
    graceMinutes: 10,
    expectedDurationMinutes: 30,
    status: "LONG_RUNNING",
    severity: "CRITICAL",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-risk-312.json",
    createdAt: "2026-05-03T14:10:00Z",
    updatedAt: "2026-06-02T12:04:00Z"
  },
  {
    id: "job-synapse-marketing-cancelled",
    name: "Marketing Attribution Refresh",
    description: "Cancelled refresh after upstream campaign source maintenance.",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-marketing",
    workspaceName: "synw-prod-marketing",
    pipelineName: "MarketingAttributionRefresh",
    triggerName: "daily-0800",
    expectedStartTime: "2026-06-02T08:00:00Z",
    cronExpression: "0 8 * * *",
    graceMinutes: 15,
    expectedDurationMinutes: 50,
    status: "CANCELLED",
    severity: "LOW",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-marketing-096.json",
    createdAt: "2026-05-06T16:20:00Z",
    updatedAt: "2026-06-02T08:12:00Z"
  },
  {
    id: "job-acr-image-build",
    name: "Data API Image Build",
    description: "ACR task that builds the data integration API image.",
    sourceType: "ACR",
    sourceName: "acrproddataops",
    pipelineName: "data-api-image-build",
    triggerName: "data-api",
    expectedStartTime: "2026-06-02T09:15:00Z",
    cronExpression: "15 9 * * 1-5",
    graceMinutes: 5,
    expectedDurationMinutes: 12,
    status: "SUCCEEDED",
    severity: "MEDIUM",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/raw/source=acr/year=2026/month=06/day=02/task-image-build-553.json",
    createdAt: "2026-04-26T11:45:00Z",
    updatedAt: "2026-06-02T09:25:00Z"
  },
  {
    id: "job-acr-base-image-scan",
    name: "Base Image Vulnerability Scan",
    description: "ACR security task failed during base image scanning.",
    sourceType: "ACR",
    sourceName: "acrprodsecurity",
    pipelineName: "base-image-vulnerability-scan",
    triggerName: "base-images",
    expectedStartTime: "2026-06-02T12:00:00Z",
    cronExpression: "0 12 * * *",
    graceMinutes: 5,
    expectedDurationMinutes: 18,
    status: "FAILED",
    severity: "HIGH",
    owner: "Samuel Kim",
    isActive: true,
    rawPayloadPath: "/integration-monitor/errors/source=acr/year=2026/month=06/day=02/task-scan-117.json",
    createdAt: "2026-05-08T18:00:00Z",
    updatedAt: "2026-06-02T12:21:00Z"
  }
];
